module.exports = __webpack_public_path__ + "img/discover-network-vector-logo.3c4a501e.png";